import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-state"];
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserStateBadge',
    props: {
        enabled: { type: Boolean },
        isInvited: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const state = computed(() => {
            if (props.isInvited)
                return "pending";
            return props.enabled ? "active" : "inactive";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["user-state-badge", `user-state-badge--${state.value}`]),
                "data-state": state.value
            }, _toDisplayString(_ctx.$t(`accessManager.users.state.${state.value}`)), 11 /* TEXT, CLASS, PROPS */, _hoisted_1));
        };
    }
});
